<template>
	<div class="labelText" :style="{height:textHeight,lineHeight:textHeight,width:componentWidth}">
		<span :style="{color:spanColor,fontSize:spanFontSize+'px',width:spanWidth,}" class="innerSpan">{{spanTitle}}:</span>
		<p :style="{color:pColor,fontSize:pFontSize+'px',width:pWidth}" class="innerP">{{pContent}}</p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		props: {
			// 默认组件宽度
			componentWidth: {
				type: String,
				default: '600px'
			},
			// span类
			spanColor:{
				type: String,
				default:'#000'
			},
			spanFontSize:{
				type:Number,
				default:15
			},
			spanTitle:{
				type:String,
				default:'标题'
			},
			spanWidth:{
				type:String,
				default:'100px'
			},
			// p类
			pColor:{
				type:String,
				default:'#000'
			},
			pFontSize:{
				type:Number,
				default:14
			},
			pContent:{
				type:String,
				default:'内容'
			},
			pWidth:{
				type:String,
				default:'auto'
			},
			textHeight:{
				type:String,
				default:'40px'
			}
		}
	}
</script>

<style>
	.labelText{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		width: auto;
		margin: 10px 10px;
	}
	.innerSpan{
		display: inline-block;
		/*display: inherit;*/
		justify-content: flex-end;
		text-align: left;
	}
	.innerP{
		display: inline-block;
		display: inherit;
		justify-content: flex-start;
		padding-left: 20px;
		text-align: left;
	}
</style>
